import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {Panel, DocumentAssignmentRules, FormLayout, Input, Display, ObjectSelect2, Select2} from 'components';
import CompanyDocumentEditState from '../state/CompanyDocumentEditState';
import CompanyDocumentEditorFactory from './CompanyDocumentEditorFactory';

const CompanyDocumentEditor = observer(({uiState}) => {
  const {companyDocument, sortedFolders, errors, recipientOptions, ruleOptions} = uiState;

  return (
    <div>
      <Display backPath='/documents'/>
      <div className='Container pb4'>
        <Panel>
          <FormLayout>
            <Input
              label='company_settings.documents.Company Document Name'
              errorMessage={errors.name}
              type='text'
              value={companyDocument.name}
              onChange={(e) => companyDocument.merge({name: e.target.value})}/>
            <Select2
              label='company_settings.documents.Language'
              value={companyDocument.locale}
              onChange={(e) => companyDocument.merge({locale: e.target.value})}>
              <option value='en'>{'English'}</option>
              <option value='fr'>{'Français'}</option>
            </Select2>
            <Select2
              label='company_settings.documents.Upload to Folder on Completion'
              allowClear
              value={companyDocument.folderId}
              onChange={(e) => companyDocument.merge({folderId: e.target.value || null})}>
              {sortedFolders.map((folder) =>
                <option key={folder.id} value={folder.id}>{folder.name}</option>
              )}
            </Select2>
            <ObjectSelect2 
              value={companyDocument.notificationRecipients}
              onAdd={recipient => companyDocument.addRecipient(recipient)}
              onRemove={recipient => companyDocument.removeRecipient(recipient)}
              items={recipientOptions}
              label='company_settings.documents.Notify on Completion'
              placeholder='company_settings.documents.e.g., Manager'
              by='value'
              multiple
              searchable={true}
            />
            <DocumentAssignmentRules companyDocument={companyDocument} ruleOptions={ruleOptions}/>
            <CompanyDocumentEditorFactory uiState={uiState}/>
          </FormLayout>
        </Panel>
      </div>
    </div>
  );
});

export default withState(CompanyDocumentEditor, CompanyDocumentEditState);
